import HeroSection from './components/HeroSection';
import ClientLine from './components/ClientLine';
import TechBadge from './components/TechBadge';
import DemoSection from './components/DemoSection';
import SiteFooter from './components/SiteFooter';
import SchemaOrg from '../../components/feature/SchemaOrg';

const siteUrl = import.meta.env.VITE_SITE_URL as string || 'https://example.com';

const faviconUrl =
  'https://static.readdy.ai/image/367838cde3a95dfce8e11451bd6c2f21/93410080c51161f9c5d98fae50fad750.png';

const homeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'KimiCodes',
    url: siteUrl,
    description:
      'Fast, modern, and conversion-focused web design for businesses and creators. KimiCodes builds websites that help you get clients and grow your brand online.',
    image: faviconUrl,
    author: {
      '@type': 'Person',
      name: 'Mihajlo Radic',
      email: 'mhradic@gmail.com',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    name: 'KimiCodes',
    url: siteUrl,
    description:
      'Web design and development studio specialising in fast, modern, and conversion-focused websites for businesses and creators.',
    logo: faviconUrl,
    image: faviconUrl,
    founder: {
      '@type': 'Person',
      name: 'Mihajlo Radic',
      email: 'mhradic@gmail.com',
    },
    email: 'mhradic@gmail.com',
    serviceType: 'Web Design & Development',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer support',
      email: 'mhradic@gmail.com',
      availableLanguage: ['English'],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Mihajlo Radic',
    email: 'mhradic@gmail.com',
    url: siteUrl,
    image: faviconUrl,
    jobTitle: 'Web Designer & Developer',
    worksFor: {
      '@type': 'Organization',
      name: 'KimiCodes',
      url: siteUrl,
    },
    knowsAbout: ['Web Design', 'Web Development', 'Frontend Development', 'UI/UX Design'],
  },
];

export default function Home() {
  return (
    <main className="relative min-h-screen" style={{ backgroundColor: '#090909' }}>
      <SchemaOrg schema={homeSchema} id="home-schema" />
      <HeroSection />
      <ClientLine />
      <DemoSection />
      <TechBadge />
      <SiteFooter />
    </main>
  );
}
